import { isPatrolmanPlusSku } from "../configuration-sku-family.js";

/** Zip tie stocked at Final QC (station 9) via manufacturing.station_stock. */
export const FINAL_QC_ZIP_TIE_SKU = "88-101-14";

export function isFinalQcZipTieStationStockSku(skuRaw: string): boolean {
  return skuRaw.trim().toLowerCase() === FINAL_QC_ZIP_TIE_SKU.toLowerCase();
}

/** Map a finished device SKU to the zip tie consumed when Final QC grades the unit. */
export function resolveFinalQcZipTieSku(finishedSkuRaw: string): string | null {
  const finishedSku = finishedSkuRaw.trim();
  if (finishedSku === "") return null;
  if (isPatrolmanPlusSku(finishedSku)) return FINAL_QC_ZIP_TIE_SKU;
  return null;
}
